import { requireAuthentication } from 'shared/containers/AuthenticatedContainer';
import AccountPage from './AccountPageContainer';

export default requireAuthentication(AccountPage, {}, { redirect: true });
